import { SimpleInput } from '@aloft/toolkit-sui';

import { Controller } from 'react-hook-form';

import { useZodFormContext } from '../../hooks/useZodForm.ts';

export function ThresholdInput({ fieldPath }: { fieldPath: string }) {
  const { control } = useZodFormContext();
  return (
    <Controller
      name={fieldPath}
      control={control}
      render={({ field }) => (
        <SimpleInput size="sm" type="number" prefix="$" useSeparator {...field} />
      )}
    />
  );
}
